import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { captureRef } from "./lib/ref.ts";

captureRef();
createRoot(document.getElementById("root")!).render(<App />);
